// extracted by mini-css-extract-plugin
module.exports = {"container":"FinishedResetPassword_container__3p1oQ","msg":"FinishedResetPassword_msg__3fpTP","confirmBtn":"FinishedResetPassword_confirmBtn__1ub-J"};